import React from 'react';
import type { MediaAttachment } from '../../../../features/messages/models/attachment';
import { getAspectRatio, isExtremeRatio } from '../../utils/image-layout-utils';
import ImageView from './image-view';
import VideoView from './video-view';

interface MediaItemProps {
  attachment: MediaAttachment;
  className?: string;
  alt?: string;
  objectFit?: 'cover' | 'contain';
}

const MediaItem: React.FC<MediaItemProps> = ({ attachment, className, alt, objectFit = 'cover' }) => {
  const descriptiveAlt = alt || `${attachment?.filename || attachment?.mediaType} attachment in message`;

  if (!attachment) return null;

  // Calculate if the image has an extreme aspect ratio
  const aspectRatio = getAspectRatio(attachment.width, attachment.height);
  const isExtreme = isExtremeRatio(aspectRatio);

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {attachment.mediaType === 'IMAGE' && (
        <ImageView
          path={attachment.url!}
          fallbackUrl={attachment.blobUrl}
          alt={descriptiveAlt}
          blurHash={attachment.blurHash}
          objectFit={objectFit}
          isExtreme={isExtreme}
          width={attachment.width}
          height={attachment.height}
        />
      )}
      {attachment.mediaType === 'VIDEO' && (
        <VideoView
          path={attachment.url!}
          alt={descriptiveAlt}
          thumbnailPath={attachment.thumbnailUrl}
          blurHash={attachment.blurHash}
        />
      )}
    </div>
  );
};

export default React.memo(MediaItem);
